"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function AppInitializer() {

    const pathname = usePathname();

    useEffect(() => {

        // Wait until React finished rendering
        const timer = setTimeout(() => {

            // Body flags
            delete document.body.dataset.homePagerBound;

            // Section flags
            document
                .querySelectorAll("[data-intro-snap-bound]")
                .forEach(el => delete (el as HTMLElement).dataset.introSnapBound);

            document
                .querySelectorAll("[data-awards-bound]")
                .forEach(el => delete (el as HTMLElement).dataset.awardsBound);

            document
                .querySelectorAll("[data-insights-bound]")
                .forEach(el => delete (el as HTMLElement).dataset.insightsBound);

            document
                .querySelectorAll("[data-showcase-bound]")
                .forEach(el => delete (el as HTMLElement).dataset.showcaseBound);

            document
                .querySelectorAll("[data-media-bound]")
                .forEach(el => delete (el as HTMLElement).dataset.mediaBound);

            document
                .querySelectorAll("[data-hero-video-bound]")
                .forEach(el => delete (el as HTMLElement).dataset.heroVideoBound);

            document
                .querySelectorAll("[data-motion-bound]")
                .forEach(el => delete (el as HTMLElement).dataset.motionBound);

            document
                .querySelectorAll("[data-stats-bound]")
                .forEach(el => delete (el as HTMLElement).dataset.statsBound);

            document
                .querySelectorAll("[data-pin-bound]")
                .forEach(el => delete (el as HTMLElement).dataset.pinBound);

            document
                .querySelectorAll("[data-menu-bound]")
                .forEach(el => delete (el as HTMLElement).dataset.menuBound);

            document
                .querySelectorAll("[data-dropdown-bound]")
                .forEach(el => delete (el as HTMLElement).dataset.dropdownBound);

            // Re-run site initialization
            if (
                typeof window !== "undefined" &&
                (window as any).layout
            ) {
                (window as any).layout();
            }

        }, 100);

        return () => clearTimeout(timer);

    }, [pathname]);

    return null;
}